import { HomeAnnouncements, HomeFavorites, HomeWorkQueues } from './components';
import { makeStyles } from '@material-ui/core';
import { Content, PageWithHeader } from '@backstage/core-components';

export const HomePage = () => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <PageWithHeader title="Home" themeId="tool">
        <Content className={classes.content}>
          <HomeAnnouncements />
          <HomeFavorites />
          <HomeWorkQueues />
        </Content>
      </PageWithHeader>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  header: {
    overflowX: 'hidden',
    width: '100%',
    '& header': {
      backgroundColor: '#1A1F36 !important',
      backgroundImage: 'none !important',
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': { color: '#00B7CF !important' },
  },
  content: {
    maxWidth: '1400px !important',
    width: '100% !important',
    padding: '24px !important',
    margin: '0 auto !important',
    '& > *': { maxWidth: '100%', boxSizing: 'border-box' },
  },
}));
